import { c as _c } from "react/compiler-runtime";
import { CapacitorCookies } from '@capacitor/core';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { AppErrorResponse } from 'record-it-time-common/AppResponse';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { CookieUtils } from '../../../classes/misc/CookieUtils/CookieUtils';
import { useAuth } from '../../useAuth';
export function useLoginFunction(t0) {
  const $ = _c(3);
  const {
    onError
  } = t0;
  const {
    setAuthenticationData
  } = useAuth();
  let t1;
  if ($[0] !== onError || $[1] !== setAuthenticationData) {
    t1 = async (email, password) => {
      const response = await ApiAdapter.login({
        email,
        password
      });
      const cookies = await CapacitorCookies.getCookies({
        url: CookieUtils.getApiCookiesUrl()
      });
      const csrfTokenCookie = cookies.csrftoken ? decodeURIComponent(cookies.csrftoken) : null;
      if (!response.success) {
        onError(response);
        return;
      }
      if (csrfTokenCookie) {
        await CapacitorCookies.deleteCookie({
          key: "csrftoken"
        });
        setAuthenticationData({
          csrfToken: csrfTokenCookie,
          userId: response.userId
        });
      } else {
        onError({
          success: false,
          error: "NO_CSRF_TOKEN",
          message: "No CSRF token received",
          details: []
        });
      }
    };
    $[0] = onError;
    $[1] = setAuthenticationData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useEventCallback(t1);
}